import type {SVGProps} from 'react';

import * as React from 'react';
const Curve1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 372 149"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_40000935_5570)">
      <path
        d="M-72.5368 148.977C-35.0115 143.906 -4.13921 119.919 25.6975 98.5012C40.808 87.6554 56.1775 76.9272 72.9827 68.8398C81.1891 64.8902 89.7408 61.6302 98.5906 59.4203C103.133 58.284 107.762 57.3749 112.422 56.8891C117.083 56.4032 123.351 56.2935 126.419 60.7917C129.008 64.5846 128.192 69.7724 126.74 73.8239C124.991 78.6904 121.602 83.4629 117.271 86.3546C112.94 89.2462 107.613 89.5989 103.525 86.0803C99.4379 82.5616 98.0335 77.4992 98.52 72.4838C99.6105 61.3167 108.853 51.2859 117.004 44.3192C125.156 37.3525 134.704 32.0942 144.668 28.2465C168.22 19.1482 193.742 18.0197 218.659 16.4759C243.639 14.9321 268.643 12.4244 292.996 6.42946C334.977 -3.90697 376.104 -25.9199 399.531 -63.4727C402.245 -67.822 404.662 -72.3515 406.796 -77.0143C407.839 -79.2947 404.458 -81.2852 403.406 -78.9891C383.879 -36.2171 341.042 -10.4348 297.036 1.34354C271.585 8.1535 245.342 10.9041 219.114 12.5263C193.349 14.125 166.839 15.2378 142.557 24.8767C132.319 28.9439 122.614 34.3668 114.219 41.5451C105.879 48.6764 97.2019 58.4877 95.0052 69.5608C93.1693 78.855 97.5 90.6333 107.927 92.4044C118.354 94.1754 126.905 84.2152 130.271 75.4774C133.637 66.7396 131.754 55.165 120.864 53.1197C115.968 52.2028 110.877 53.0335 106.028 53.8485C101.18 54.6635 96.7939 55.7214 92.2827 57.0693C73.7594 62.6019 56.8365 72.382 40.8786 83.0945C8.82949 104.622 -21.5014 132.316 -59.6701 142.417C-64.2519 143.632 -68.9043 144.549 -73.6038 145.184C-76.0909 145.521 -75.0317 149.298 -72.5604 148.961L-72.5368 148.977Z"
        fill="url(#paint0_linear_40000935_5570)"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_40000935_5570"
        x1={-66.2268}
        x2={392.04}
        y1={30.3085}
        y2={30.3085}
      >
        <stop stopColor="#FF3A8B" />
        <stop
          offset={1}
          stopColor="#FFBA4A"
        />
      </linearGradient>
      <clipPath id="clip0_40000935_5570">
        <rect
          fill="white"
          height={230}
          transform="translate(-76 -81)"
          width={483}
        />
      </clipPath>
    </defs>
  </svg>
);
export default Curve1;
